// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_selection_tags'],
      sections: [
        addPanel.sections.getSections().developer.selectionTagsListSection,
      ],
    };
  },
};
